import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 51.498 51.498"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g data-name=\"Group 4221\"><g data-name=\"Group 4223\"><path data-name=\"Path 8023\" d=\"M17 8v11.863h13.558v-3.389H20.389V8z\" transform=\"translate(4.143 2.163)\" style=\"fill:#fff;\"></path><g data-name=\"Group 4222\"><path data-name=\"Path 8021\" d=\"M7.957 17H4.524l4.043 18.642h13.71L25.667 17zm13.863 3.389-2.084 11.864h-8.474L8.567 20.389z\" transform=\"translate(-4.524 8.416)\" style=\"fill:#fff;\"></path><path data-name=\"Path 8022\" d=\"M31.726 2.71A18.642 18.642 0 0 0 8 20.64 21.709 21.709 0 0 0 8.153 23l.2 1.119h3.389a15.253 15.253 0 1 1 20.052 10.96 15.048 15.048 0 0 1-6.237.847l-.407 3.389A18.642 18.642 0 0 0 31.726 2.71z\" transform=\"translate(-2.11 -2.003)\" style=\"fill:#fff;\"></path><path data-name=\"Path 8024\" d=\"M15.779 21H9v3.389h6.779z\" transform=\"translate(-1.415 11.195)\" style=\"fill:#fff;\"></path></g></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };